import { ReactNode } from 'react';
import Loader from '../Loader';
import { CardShell } from './common';
import { HeadingScope } from '@acast-tech/decibel';

type HighlightCardProps = {
  title: string | ReactNode;
  className?: string;
  value?: string | ReactNode;
  loading?: boolean;
};

const HighlightCard = ({ className, title, value, loading }: HighlightCardProps) => {
  return (
    <CardShell className={className}>
      <h6 className="text-textMedGrey text-xs lg:text-base mb-2">{title}</h6>
      <HeadingScope>
        {loading ? (
          <Loader />
        ) : typeof value === 'string' ? (
          <h4
            className="text-textDarkGrey text-md lg:text-2xl font-bold font-telegraf"
            title={value}
          >
            {value}
          </h4>
        ) : value !== undefined ? (
          value
        ) : null}
      </HeadingScope>
    </CardShell>
  );
};

export default HighlightCard;
